import { useDispatch } from "react-redux";
import { getParsedToken } from "../components/utils";
import { checkAccess } from "../model/system/constants";
import { deleteCookie, getCookie } from "../utils/utils";
import { USERPOSITIONS } from "../constants/userPositions";
import {
  getRole,
  AvailableRoles,
  RolesWithAccessFromCookies,
} from "../constants/roles";
import {
  getCurrentUser,
  getCurrentUserWithoutHeadersMerchant,
} from "../model/system/dSystemAPI";
import {
  authAC,
  authErrorAC,
  logoutSagaAC,
  setCurrentUserInfoAC,
} from "../model/system/systemActionCreators";

export function useCheckAuth(auth: boolean) {
  const dispatch = useDispatch();

  if (!auth) {
    //check remote control
    const token = getCookie("tindaRemoteToken");
    const refreshToken = getCookie("tindaRemoteRefreshToken");
    const expAccessToken = getCookie("expRemoteToken");
    const expRefreshToken = getCookie("expRemoteRefreshToken");

    if (token && refreshToken) {
      const parsedToken = getParsedToken(token);
      // check for access from cookie
      const role = getRole(parsedToken.realm_access.roles);
      if (role && RolesWithAccessFromCookies.includes(role)) {
        const toLocalData = {
          accessToken: token,
          refreshToken: refreshToken,
          expAccessToken: expAccessToken,
          expRefreshToken: expRefreshToken,
        };

        localStorage.setItem("authData", JSON.stringify(toLocalData));
        localStorage.setItem("login", JSON.stringify(parsedToken.email));

        deleteCookie("tindaRemoteToken");
        deleteCookie("tindaRemoteRefreshToken");

        // get current user info for remote control
        getCurrentUserWithoutHeadersMerchant(token)
          .then((resp) => {
            if (resp.status === 200) {
              // check access by role && position
              const role = getRole(resp.data.authorizedUser.roles);
              // super admin has position: null
              const position =
                resp.data.position !== null
                  ? resp.data.position
                  : role === AvailableRoles.ROLE_TINDA_SUPER_ADMIN ||
                      role === AvailableRoles.ROLE_TINDA_ADMIN
                    ? USERPOSITIONS.ADMIN
                    : null;
              if (checkAccess(role, position)) {
                dispatch(
                  setCurrentUserInfoAC({ ...resp.data, position: position }),
                );
                dispatch(
                  authAC(getParsedToken(resp.data.authorizedUser.token).email),
                );

                document.cookie = `to=${getParsedToken(resp.data.authorizedUser.token).email.email}; path=/; domain=${process.env.REACT_APP_DOMAIN}; max-age=2592000`;

                dispatch(authErrorAC(false));
              } else {
                dispatch(logoutSagaAC());
              }
            } else {
              dispatch(logoutSagaAC());
            }
          })
          .catch((err) => {
            console.log(err);
            dispatch(logoutSagaAC());
          });
      } else {
        dispatch(logoutSagaAC());
      }
    } else {
      const authData = localStorage.getItem("authData");
      const login = localStorage.getItem("login");

      if (authData && login) {
        dispatch(authAC(JSON.parse(login)));

        // get current user info
        const remoteMerchantId = getCookie("tindaRemoteMerchant");
        const currentUser = remoteMerchantId
          ? getCurrentUserWithoutHeadersMerchant(
              JSON.parse(authData).accessToken,
            )
          : getCurrentUser(JSON.parse(authData).accessToken);

        currentUser
          .then((resp) => {
            if (resp.status === 200) {
              // check access by role && position
              const role = getRole(resp.data.authorizedUser.roles);
              // super admin has position: null
              const position = resp.data.position
                ? resp.data.position
                : role === AvailableRoles.ROLE_TINDA_SUPER_ADMIN ||
                    role === AvailableRoles.ROLE_TINDA_ADMIN
                  ? USERPOSITIONS.ADMIN
                  : null;
              if (checkAccess(role, position)) {
                dispatch(
                  setCurrentUserInfoAC({ ...resp.data, position: position }),
                );
                dispatch(
                  authAC(getParsedToken(resp.data.authorizedUser.token).email),
                );

                document.cookie = `to=${getParsedToken(resp.data.authorizedUser.token).email.email}; path=/; domain=${process.env.REACT_APP_DOMAIN}; max-age=2592000`;

                dispatch(authErrorAC(false));
              } else {
                dispatch(logoutSagaAC());
              }
            } else {
              dispatch(logoutSagaAC());
            }
          })
          .catch((err) => {
            console.log(err);
            dispatch(logoutSagaAC());
          });
      }
    }
  }
}
